import { render, staticRenderFns } from "./blockModal.vue?vue&type=template&id=1c5545b8&scoped=true"
import script from "./blockModal.vue?vue&type=script&lang=js"
export * from "./blockModal.vue?vue&type=script&lang=js"
import style0 from "./blockModal.vue?vue&type=style&index=0&id=1c5545b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5545b8",
  null
  
)

export default component.exports